import * as React from 'react';

const SvgSuccessOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M10.887 17.5 6 12.6l1.412-1.412 3.475 3.487L17.6 8 19 9.425 10.887 17.5Z", fill: "currentColor" })));

export { SvgSuccessOutline as default };
